export const StepTitle = ({ n, title, hint }) => (
  <div className="mb-5 flex items-baseline gap-3">
    <span className="font-tech text-xs text-[#FF3333]">0{n}</span>
    <h2 className="font-display text-lg font-semibold uppercase tracking-wide text-white">{title}</h2>
    {hint && <span className="font-tech text-[10px] uppercase tracking-[0.2em] text-zinc-500">{hint}</span>}
  </div>
);
